module.exports = __webpack_public_path__ + "media/images/advisor/img_5_2-8856777f46aa81a1c71c521dc8411c79.png";